import { useEffect } from "react";
import { createContext, useState } from "react";


export const MobileContext = createContext();

export const MobileProvider = ({ children }) => {
    const [isOnMobile, setIsOnMobile] = useState(() => {
        const savedState = localStorage.getItem('isOnMobile');
        return savedState !== null ? JSON.parse(savedState) : window.innerWidth <= 768;
    });

    useEffect(() => {
        const handleResize = () => {
            const newIsOnMobile = window.innerWidth <= 768;
            setIsOnMobile(newIsOnMobile);
            localStorage.setItem('isOnMobile', JSON.stringify(newIsOnMobile));
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    return (
        <MobileContext.Provider value={
            {
                isOnMobile
            }}>
            {children}
        </MobileContext.Provider>
    )
}